/* Fransk katalog for locale-invoice-detail-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'inv.pay.originalAmount': 'Montant en {currency}',
  'inv.pay.bankAmountCurrency': 'Montant bancaire en {currency}',
  'inv.pay.fxPreview': 'La créance est soldée à {receivable} {accountingCurrency}. L\'écart avec le montant bancaire est comptabilisé en {kind} : {difference}.',
  'inv.pay.fxGain': 'gain de change',
  'inv.pay.fxLoss': 'perte de change',
});
